<div class="admin container-fluid d-flex flex-column" #page_listener>
  <!------- HEADER --------->
  <div class="w-100 d-flex justify-content-between flex-shrink-0 pt-4">
    <h1 class="title_1 m-0">
      {{properties.length}}
      Propriétés
      <mat-icon class="ms-2 me-4 pointer font-18" (click)="fetchProperties()"> autorenew</mat-icon>
    </h1>

    <div class="d-flex flex-row justify-content-end align-items-center gap-24">
      <mat-form-field (keyup.enter)="applyFilter(); searched=true" class="search_box">
        <mat-icon class="search-icon" aria-hidden="false" aria-label="Example home icon" fontIcon="search"></mat-icon>
        <input matInput [(ngModel)]="searchVal" placeholder="Rechercher" (input)="checkEmptySearch()">
      </mat-form-field>
      <input (click)="applyFilter(); searched=true" class="btn btn-primary btn-sm" type="submit"/>
      <div class="searchLegend">
        <i>Ref partenaire, Ref Livinfrance, <br/>
          Nom du partenaire, Nom livinfrance</i><br/>
        <b>La recherche s'effectue sur la sélection</b>
      </div>
    </div>
  </div>
  <div class="bg-white sticky-top pt-4">
    <!-- FILTRES & SORT -->
    <div class="row w-100 mx-0 px-0 border-bottom pb-3">
      <div class="filters col-10 mx-0 p-0 d-flex flex-row flex-wrap gap-3">
        <mat-form-field [ngClass]="{'selected': statusFilter.value}" *ngIf="properties">
          <mat-label>Status</mat-label>
          <mat-select [formControl]="statusFilter">
            <mat-option (click)="hasChangedFilter = true; doFilter()" [value]="null">Tous</mat-option>
            <mat-option (click)="hasChangedFilter = true; doFilter()" *ngFor="let item of statusList; trackBy:trackByIndex" [value]="item.value">{{item.name}}</mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field [ngClass]="{'selected': partnerFilter.value}" *ngIf="partnerList && partnerList.length > 0">
          <mat-label>Partenaires</mat-label>
          <mat-select [formControl]="partnerFilter">
            <mat-option (click)="hasChangedFilter = true; doFilter()" [value]="null">Tous</mat-option>
            <mat-option (click)="hasChangedFilter = true; doFilter()"
              *ngFor="let partner of partnerList; trackBy: trackByIndex" [value]="partner">{{ partner | titlecase }}</mat-option>
          </mat-select>
        </mat-form-field>

        <div class="dropdown py-0 d-sm-flex align-items-center bg-white border-1 text-nowrap"
          [ngClass]="{'selected': (minPriceFilter && minPriceFilter.value) || (maxPriceFilter && maxPriceFilter.value)}">
          <button (click)="dispPrFilter = !dispPrFilter" class="dropbtn btn rounded-pill pointer">
            <span class="label">Prix</span>
            <span *ngIf="minPriceFilter && minPriceFilter.value">
                {{ minPriceFilter.value }}
              <span *ngIf="maxPriceFilter && maxPriceFilter.value"> - </span>
              </span>
            <span *ngIf="maxPriceFilter && maxPriceFilter.value">
                {{ maxPriceFilter.value }}
            </span>

          </button>
          <div *ngIf="dispPrFilter" id="myDropdown" class="dropdown-content d-flex flex-column gap-16 bg-white py-3 px-2">
            <input class="minitext_3 border-0" numberOnly [formControl]="minPriceFilter" (blur)="hasChangedFilter = true; doFilter()"
              type="number" min="0"
              placeholder="Prix min"/>

            <input class="minitext_3 border-0" numberOnly [formControl]="maxPriceFilter" (blur)="hasChangedFilter = true; doFilter()"
              type="number" min="0" placeholder="Prix max"/>
          </div>
        </div>

        <div class="dropdown pe-3 py-0 d-sm-flex align-items-center bg-white border-1 text-nowrap" [ngClass]="{'selected':dispoFilter}" *ngIf="properties && showMoreFilters">
          <button (click)="dispDateFilter = !dispDateFilter" class="dropbtn btn rounded-pill pointer">
            <div class="label">Disponibilité</div>
            <ng-container *ngIf="dispoFilter">
              <div *ngIf="dispoFilter !== 'date' ; else dateSelectedTmpt">{{ dispoFilter }}</div>
              <ng-template #dateSelectedTmpt>
                <span *ngIf="dateRange.controls.start.value"> {{ dateRange.controls.start.value | date:'shortDate':'':'fr' }} </span>
                -
                <span *ngIf="dateRange.controls.end.value"> {{ dateRange.controls.end.value  | date:'shortDate':'':'fr' }} </span>
              </ng-template>
            </ng-container>

          </button>
          <div *ngIf="dispDateFilter" id="dateDropDown" class="dropdown-content dateDropDown d-flex flex-column gap-16 bg-white py-3 px-2">
            <mat-radio-group [(ngModel)]="dispoFilter" (ngModelChange)="hasChangedFilter = true; doFilter()" class="d-flex gap-16 flex-wrap">
              <mat-radio-button *ngFor="let value of dispoArray"
                [ngClass]="{'fw-bold' : dispoFilter == value.value}" class="text_2" value="{{value.value}}">
                {{ value.name }}
              </mat-radio-button>
            </mat-radio-group>

            <div class="d-flex flex-column gap-8" *ngIf="dispoFilter == 'date' ">
              <mat-form-field class="rangeInput">
                <mat-date-range-input [formGroup]="dateRange" [rangePicker]="picker">
                  <input matStartDate formControlName="start" placeholder="Start date">
                  <input matEndDate formControlName="end" placeholder="End date">
                </mat-date-range-input>
                <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
                <mat-date-range-picker #picker></mat-date-range-picker>
              </mat-form-field>
              <button type="submit" (click)="hasChangedFilter = true; doFilter();dispDateFilter = !dispDateFilter"
                class="btn btn-sm btn-primary">
                Ok
              </button>
            </div>
          </div>
        </div>

        <div class="d-flex gap-3 flex-wrap">
          <div class="customFilter position-relative" [ngClass]="{'selected':cityFilter.value }">
            <div class="label">Métropoles</div>
            <select2 (open)="fillSelectCity()" [formControl]="cityFilter" [data]="citySelectList" resettable
              resetSelectedValue="null" (ngModelChange)="hasChangedFilter = true; doFilter()"
              displaySearchStatus="always" styleMode="noStyle" [placeholder]="null"></select2>
          </div>

          <div class="customFilter position-relative" [ngClass]="{'selected':subCityFilter.value }">
            <div class="label">Villes</div>
            <select2 (open)="fillSelectsubCity()" [formControl]="subCityFilter" resettable resetSelectedValue="null"
              [data]="subCitySelectList" minCharForSearch="2"
              minCountForSearch="3"
              maxResults="20" resettable (ngModelChange)="hasChangedFilter = true; doFilter()"
              displaySearchStatus="always" styleMode="noStyle" [placeholder]="null"></select2>
          </div>

          <div class="customFilter position-relative" [ngClass]="{'selected':contactFilter.value }">
            <div class="label">Gestionnaires</div>
            <select2 (open)="fillSelectContact()" class="" [formControl]="contactFilter"
              [data]="contactSelectList" resettable resetSelectedValue="null" (ngModelChange)="hasChangedFilter = true; doFilter()"
              displaySearchStatus="always" styleMode="noStyle" [placeholder]="null"></select2>
          </div>
        </div>

        <ng-container *ngIf="properties && showMoreFilters">
          <mat-form-field [ngClass]="{'selected':typeFilter.value}">
            <mat-label>Type</mat-label>
            <mat-select [formControl]="typeFilter">
              <mat-option (click)="hasChangedFilter = true; doFilter()" [value]="null">Tous</mat-option>
              <mat-option (click)="hasChangedFilter = true; doFilter()" [value]="'room'">Colocation</mat-option>
              <mat-option (click)="hasChangedFilter = true; doFilter()" [value]="'apartment'">Logement entier
              </mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field [ngClass]="{'selected':isStudentResidenceFilter.value}">
            <mat-label>Résidence étudiante</mat-label>
            <mat-select [formControl]="isStudentResidenceFilter">
              <mat-option (click)="hasChangedFilter = true; doFilter()" [value]="null">Tous</mat-option>
              <mat-option (click)="hasChangedFilter = true; doFilter()" [value]="true">Oui</mat-option>
              <mat-option (click)="hasChangedFilter = true; doFilter()" [value]="false">Non</mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field [ngClass]="{'selected':photoFilter.value}">
            <mat-label>Photos</mat-label>
            <mat-select [formControl]="photoFilter">
              <mat-option (click)="hasChangedFilter = true; doFilter()" [value]="null">Tous</mat-option>
              <mat-option (click)="hasChangedFilter = true; doFilter()" [value]="'avec'">avec photos</mat-option>
              <mat-option (click)="hasChangedFilter = true; doFilter()" [value]="'sans'">sans photos</mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field [ngClass]="{'selected':featuredFilter.value}">
            <mat-label>Is featured / Mis en avant</mat-label>
            <mat-select [formControl]="featuredFilter">
              <mat-option (click)="hasChangedFilter = true; doFilter()" [value]="null">Tous</mat-option>
              <mat-option (click)="hasChangedFilter = true; doFilter()" [value]="'1'">Oui</mat-option>
              <mat-option (click)="hasChangedFilter = true; doFilter()" [value]="'0'">Non</mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field [ngClass]="{'selected':countryFilter.value}">
            <mat-label>Pays</mat-label>
            <mat-select [formControl]="countryFilter">
              <mat-option (click)="hasChangedFilter = true; doFilter()" [value]="null">Tous</mat-option>
              <mat-option (click)="hasChangedFilter = true; doFilter()" [value]="'fr'">France</mat-option>
            </mat-select>
          </mat-form-field>

          <div class="dropdown py-0 d-sm-flex align-items-center bg-white border-1 text-nowrap">
            <button (click)="dispVerifDropDown = !dispVerifDropDown" class="dropbtn btn rounded-pill position-relative">
              <div class="label">Vérification</div>
            </button>
            <div *ngIf="dispVerifDropDown" id="verifDropDown" class="dropdown-content long_dropdown d-flex flex-column gap-8 bg-white py-3 px-2">
              <div>
                <div>
                  <b>Visite virtuelle</b>
                  <mat-radio-group [(ngModel)]="checkVVFilter" class="d-flex gap-8 mb-2">
                    <mat-radio-button *ngFor="let value of checkVV"
                      [ngClass]="{'fw-bold' : checkVVFilter == value.value}" class="text_2" value="{{value.value}}">
                      {{ value.name }}
                    </mat-radio-button>
                  </mat-radio-group>

                </div>
                <div>
                  <b> Photos</b>
                  <mat-radio-group [(ngModel)]="checkPhotosFilter" class="d-flex gap-8 mb-2">
                    <mat-radio-button *ngFor="let value of checkVV"
                      [ngClass]="{'fw-bold' : checkVVFilter == value.value}" class="text_2" value="{{value.value}}">
                      {{ value.name }}
                    </mat-radio-button>
                  </mat-radio-group>
                </div>
                <div>
                  <b> WC privé</b>
                  <mat-radio-group [(ngModel)]="checkWCPrvFilter" class="d-flex gap-8 mb-2">
                    <mat-radio-button *ngFor="let value of checkVV"
                      [ngClass]="{'fw-bold' : checkVVFilter == value.value}" class="text_2" value="{{value.value}}">
                      {{ value.name }}
                    </mat-radio-button>
                  </mat-radio-group>
                </div>
                <div>
                  <b>Salle de bain privé</b>
                  <mat-radio-group [(ngModel)]="checkBathroomPrvFilter" class="d-flex gap-8 mb-2">
                    <mat-radio-button *ngFor="let value of checkVV"
                      [ngClass]="{'fw-bold' : checkVVFilter == value.value}" class="text_2" value="{{value.value}}">
                      {{ value.name }}
                    </mat-radio-button>
                  </mat-radio-group>
                </div>
                <div>
                  <b>Nombre WC</b>
                  <mat-radio-group [(ngModel)]="checkWCNbFilter" class="d-flex gap-8 mb-2">
                    <mat-radio-button *ngFor="let value of checkVV"
                      [ngClass]="{'fw-bold' : checkVVFilter == value.value}" class="text_2" value="{{value.value}}">
                      {{ value.name }}
                    </mat-radio-button>
                  </mat-radio-group>
                </div>
                <div>
                  <b>Nombre salle de bain</b>
                  <mat-radio-group [(ngModel)]="checkBathroomNbFilter" class="d-flex gap-8 mb-2">
                    <mat-radio-button *ngFor="let value of checkVV"
                      [ngClass]="{'fw-bold' : checkVVFilter == value.value}" class="text_2" value="{{value.value}}">
                      {{ value.name }}
                    </mat-radio-button>
                  </mat-radio-group>
                </div>
              </div>
              <button (click)="hasChangedFilter = true; doFilter();dispVerifDropDown = !dispVerifDropDown" class="mt-2 btn btn-sm btn-primary">
                Ok
              </button>
            </div>
          </div>

          <mat-form-field [ngClass]="{'selected':nbRoomsFilter.value}">
            <mat-label>Nb de chambres dispo</mat-label>
            <mat-select [formControl]="nbRoomsFilter">
              <mat-option (click)="hasChangedFilter = true; doFilter()" [value]="null">Tous</mat-option>
              <mat-option (click)="hasChangedFilter = true; doFilter()" *ngFor="let item of [1,2,3,4,5,6,7,8,'8+'];trackBy:trackByIndex" [value]="item">{{item}}</mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field [ngClass]="{'selected':colocSizeFilter.value}">
            <mat-label>Taille colocation</mat-label>
            <mat-select [formControl]="colocSizeFilter">
              <mat-option (click)="hasChangedFilter = true; doFilter()" [value]="null">Tous</mat-option>
              <mat-option (click)="hasChangedFilter = true; doFilter()" [value]="'small'">Petite (2-5)</mat-option>
              <mat-option (click)="hasChangedFilter = true; doFilter()" [value]="'big'">Grande (6-9)</mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field [ngClass]="{'selected':minDurationFilter.value}">
            <mat-label>Durée de séjour</mat-label>
            <mat-select [formControl]="minDurationFilter">
              <mat-option (click)="hasChangedFilter = true; doFilter()" [value]="null">Tous</mat-option>
              <mat-option (click)="hasChangedFilter = true; doFilter()" [value]="'2'">1-2 mois</mat-option>
              <mat-option (click)="hasChangedFilter = true; doFilter()" [value]="'6'">2-6 mois</mat-option>
              <mat-option (click)="hasChangedFilter = true; doFilter()" [value]="'12'">6-12 mois</mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field [ngClass]="{'selected':bathroomFilter.value}">
            <mat-label>Salle de bain privée</mat-label>
            <mat-select [formControl]="bathroomFilter">
              <mat-option (click)="hasChangedFilter = true; doFilter()" [value]="null">Tous</mat-option>
              <mat-option (click)="hasChangedFilter = true; doFilter()" [value]="'1'">Oui</mat-option>
              <mat-option (click)="hasChangedFilter = true; doFilter()" [value]="'0'">Non</mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field [ngClass]="{'selected':wcFilter.value}">
            <mat-label>Toilettes privés</mat-label>
            <mat-select [formControl]="wcFilter">
              <mat-option (click)="hasChangedFilter = true; doFilter()" [value]="null">Tous</mat-option>
              <mat-option (click)="hasChangedFilter = true; doFilter()" [value]="'1'">Oui</mat-option>
              <mat-option (click)="hasChangedFilter = true; doFilter()" [value]="'0'">Non</mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field [ngClass]="{'selected':genderFilter.value}">
            <mat-label>Majorité d'un genre</mat-label>
            <mat-select [formControl]="genderFilter">
              <mat-option (click)="hasChangedFilter = true; doFilter()" [value]="null">Tous</mat-option>
              <mat-option (click)="hasChangedFilter = true; doFilter()" [value]="'F'">Fille</mat-option>
              <mat-option (click)="hasChangedFilter = true; doFilter()" [value]="'M'">Garçon</mat-option>
            </mat-select>
          </mat-form-field>

          <div class="dropdown py-0 d-sm-flex align-items-center bg-white border-1 text-nowrap">
            <button (click)="dispChargesDropDown = !dispChargesDropDown" class="dropbtn btn rounded-pill position-relative droptbtnLarger">
              <div class="label"> Charges comprises</div>
            </button>
            <div *ngIf="dispChargesDropDown" id="chargesDropDown" class="dropdown-content long_dropdown d-flex flex-column gap-8 bg-white py-3 px-2">
              <mat-checkbox *ngFor="let c of chargesList "
                [(ngModel)]="c.checked"
                (ngModelChange)="setChargesFilters()"
                id="{{c.value}}"
                class="w-fit-content px-0 text_2">
                {{c.name}}
              </mat-checkbox>
              <button (click)="hasChangedFilter = true; doFilter();dispChargesDropDown = !dispChargesDropDown" class="btn btn-sm btn-primary">
                Ok
              </button>
            </div>
          </div>

          <mat-form-field [ngClass]="{'selected':badgesFilter.value }">
            <mat-label>Badges</mat-label>
            <mat-select [formControl]="badgesFilter">
              <mat-option (click)="hasChangedFilter = true; doFilter()" [value]="null">Tous</mat-option>
              <mat-option (click)="hasChangedFilter = true; doFilter()" *ngFor="let item of badgesList; trackBy:trackByIndex" [value]="item.value">{{item.name}}</mat-option>
            </mat-select>
          </mat-form-field>


          <mat-form-field [ngClass]="{'selected':blockedFilter.value}">
            <mat-label>Bloqués</mat-label>
            <mat-select [formControl]="blockedFilter">
              <mat-option (click)="hasChangedFilter = true; doFilter();" [value]="null">Tous</mat-option>
              <mat-option (click)="hasChangedFilter = true; doFilter()" [value]="'1'">Oui</mat-option>
              <mat-option (click)="hasChangedFilter = true; doFilter()" [value]="'0'">Non</mat-option>
            </mat-select>
          </mat-form-field>

          <ng-container *ngIf="blockedFilter.value === '1'">
            <mat-form-field [ngClass]="{'selected':blockedReasonFilter.value}">
              <mat-label>Raison blocage</mat-label>
              <mat-select [formControl]="blockedReasonFilter">
                <mat-option (click)="hasChangedFilter = true; doFilter();" [value]="null">Tous</mat-option>
                <mat-option *ngFor="let blockReason of blockList; trackBy:trackByIndex trackBy:trackByIndex" (click)="hasChangedFilter = true; doFilter();" [value]="blockReason">
                  {{ blockReason }}
                </mat-option>
              </mat-select>
            </mat-form-field>

            <mat-form-field [ngClass]="{'selected':blockedByFilter.value}">
              <mat-label>Bloqué par:</mat-label>
              <mat-select [formControl]="blockedByFilter">
                <mat-option (click)="hasChangedFilter = true; doFilter();" [value]="null">Tous</mat-option>
                <mat-option *ngFor="let agent of blockByList; trackBy:trackById" (click)="hasChangedFilter = true; doFilter();" [value]="agent.id">
                  {{ agent.firstname | titlecase }} {{ agent.lastname  | titlecase }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </ng-container>

          <mat-form-field [ngClass]="{'selected':bypassFilter.value}">
            <mat-label>Bypass</mat-label>
            <mat-select [formControl]="bypassFilter">
              <mat-option (click)="hasChangedFilter = true; doFilter()" [value]="null">Tous</mat-option>
              <mat-option (click)="hasChangedFilter = true; doFilter()" [value]="'1'">Oui</mat-option>
              <mat-option (click)="hasChangedFilter = true; doFilter()" [value]="'0'">Non</mat-option>
            </mat-select>
          </mat-form-field>

          <ng-container *ngIf="bypassFilter.value === '1'">
            <mat-form-field [ngClass]="{'selected':bypassReasonFilter.value}">
              <mat-label>Raison bypass</mat-label>
              <mat-select [formControl]="bypassReasonFilter">
                <mat-option (click)="hasChangedFilter = true; doFilter();" [value]="null">Tous</mat-option>
                <mat-option *ngFor="let bypassReason of bypassFilterList; trackBy:trackByIndex" (click)="hasChangedFilter = true; doFilter();" [value]="bypassReason">
                  {{ bypassReason }}
                </mat-option>
              </mat-select>
            </mat-form-field>

            <mat-form-field [ngClass]="{'selected':bypassByFilter.value}">
              <mat-label>Bypass par:</mat-label>
              <mat-select [formControl]="bypassByFilter">
                <mat-option (click)="hasChangedFilter = true; doFilter();" [value]="null">Tous</mat-option>
                <mat-option *ngFor="let agent of byPassList; trackBy:trackById" (click)="hasChangedFilter = true; doFilter();" [value]="agent.id">
                  {{ agent.firstname }} {{ agent.lastname }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </ng-container>

        </ng-container>
      </div>

      <div class="col-2 d-flex flex-column justify-content-between">
        <div class="d-flex gap-16">
          <button (click)="showMoreFilters = !showMoreFilters" class="btn btn-primary">
            <i class="fa fa-sliders" aria-hidden="true"></i>
          </button>
          <button type="submit" class="btn btn-primary" (click)="doFilter()">Filtrer</button>
          <button type="reset" (click)="clearFilter()" class="btn btn-danger">
            Clear
          </button>
        </div>

        <mat-form-field class="pb-0">
          <mat-label>Trier par</mat-label>
          <mat-select [formControl]="sortBy">
            <mat-option (click)="sortData({active:'', direction:''})">
              Aucun tri
            </mat-option>
            <mat-option [value]="'Nom'" (click)="sortData({active:'name', direction:''})">
              <span class="pointer position-relative"
                [ngClass]="{'asc': sortFirstColumn.name.direction === 'asc', 'desc': sortFirstColumn.name.direction === 'desc'}">
                Nom
              </span>
            </mat-option>
            <mat-option [value]="'ID'" (click)="sortData({active:'id', direction:''})">
              <span class="pointer position-relative"
                [ngClass]="{'asc': sortFirstColumn.id.direction === 'asc', 'desc': sortFirstColumn.id.direction === 'desc'}">
                    ID
              </span>
            </mat-option>
            <mat-option [value]="'Ville'" (click)="sortData({active:'city', direction:''})">
              <span class="pointer position-relative"
                [ngClass]="{'asc': sortFirstColumn.city.direction === 'asc', 'desc': sortFirstColumn.city.direction === 'desc'}">
                    Ville
              </span>
            </mat-option>
            <mat-option [value]="'Reférence partenaire'" (click)="sortData({active:'partnerRef', direction:''})">
              <span class="pointer position-relative"
                [ngClass]="{'asc': sortFirstColumn.partnerRef.direction === 'asc', 'desc': sortFirstColumn.partnerRef.direction === 'desc'}">
                    Référence partenaire
              </span>
            </mat-option>
            <mat-option [value]="'Date de création'" (click)="sortData({active:'date', direction:''})">
              <span class="pointer position-relative"
                [ngClass]="{'asc': sortFirstColumn.date.direction === 'asc', 'desc': sortFirstColumn.date.direction === 'desc'}">
                    Date de création
              </span>
            </mat-option>
            <mat-option [value]="'Vérifiée'" (click)="sortData({active:'isVerified', direction:''})">
              <span class="pointer position-relative"
                [ngClass]="{'asc': sortFirstColumn.isVerified.direction === 'asc', 'desc': sortFirstColumn.isVerified.direction === 'desc'}">
                    Vérifiée
              </span>
            </mat-option>
            <mat-option [value]="'Date de dispo'" (click)="sortData({active:'dateDispo', direction:''})">
              <span class="pointer position-relative"
                [ngClass]="{'asc': sortFirstColumn.date.direction === 'asc', 'desc': sortFirstColumn.date.direction === 'desc'}">
                    Disponibilité
              </span>
            </mat-option>
          </mat-select>
        </mat-form-field>

      </div>
    </div>

    <!-- SELECTION -->
    <div class="d-flex py-2 copyContainer">
      <input type="checkbox" [(ngModel)]="selectAll" (change)="selectAllItems()" class="me-3 checkboxGrey"/>- Sélection
      ({{selectedElements.length}})
      <svg (click)="copyToClipboard()" class="mt-1 iconCopy ms-3 me-1" xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 512 512" ngbPopover="Copié !">
        <path d="M464 0H144c-26.51 0-48 21.49-48 48v48H48c-26.51 0-48 21.49-48 48v320c0 26.51 21.49 48 48 48h320c26.51 0 48-21.49 48-48v-48h48c26.51 0 48-21.49 48-48V48c0-26.51-21.49-48-48-48zM362 464H54a6 6 0 0 1-6-6V150a6 6 0 0 1 6-6h42v224c0 26.51 21.49 48 48 48h224v42a6 6 0 0 1-6 6zm96-96H150a6 6 0 0 1-6-6V54a6 6 0 0 1 6-6h308a6 6 0 0 1 6 6v308a6 6 0 0 1-6 6z"/>
      </svg>
      <p>|</p>
      <button (click)="resetMultiplePhotos(selectedElements)" class="btn btn-sm btn-primary py-1 ms-1" [disabled]="isResettingPhotos || selectedElements.length === 0">
        <i class="fa fa-refresh" aria-hidden="true"></i></button>
      <div class="d-flex ms-5 blockBtn" *ngIf="selectedElements && selectedElements.length > 0">
        <button (click)="openSelectionModalb(blockModal)" class="btn btn-outline-danger px-4 py-2">Blocage</button>
        <p>|</p>
        <button (click)="openModalSelectionbypass(bypassSelectionModal)" class="btn btn-outline-warning px-4 py-2 text-nowrap">
          By-pass
        </button>
        <p>|</p>
        <button (click)="openModalBadgeSelection(badgeParams)" class="btn btn-outline-success px-4 py-2 text-nowrap">
          Marketing
        </button>

      </div>
    </div>
  </div>


  <!-- LIST PROPERTIES -->
  <div class="w-100 position-relative flex-grow-1" #topproperties>

    <div class="flex-grow-1 d-flex align-items-center justify-content-center" *ngIf="properties && properties.length === 0">
      <div class="spinner-border text-primary"></div>
    </div>

    <table mat-table *ngIf="properties && properties.length !== 0" [dataSource]="dataSource" class="" matSort (matSortChange)="sortData($event)">

      <!-- Property basic informations Column -->
      <ng-container matColumnDef="property">
        <th mat-header-cell *matHeaderCellDef class="border-bottom-0"></th>
        <td mat-cell *matCellDef="let element" class="py-3 border-top-0 border-bottom-0 border-end property_infos">
          <div class="d-flex flex-row align-items-center">

            <input type="checkbox" [ngModel]="isChecked('property',element)" (ngModelChange)="toggleCheckbox('property', $event, element)" class="me-3 checkboxGrey"/>

            <div>
              <img checkurl [src]="element.cover_photo" alt="" class="img-cover br-6" loading="lazy"/>
              <div class="text-center mt-3" *ngIf="element.partner.key == 'MONBELAPPART' || element.partner.key == 'COLONIES' || element.partner.key == 'COLIVYS' || element.partner.key == 'COLOCATERE' || element.partner.key == 'CHEZNESTOR'  ">
                <button (click)="resetPhotos(element)" class="btn btn-sm btn-primary py-1" [disabled]="isResettingPhotos">
                  <i class="fa fa-refresh" aria-hidden="true"></i></button>
              </div>
            </div>
            <div class="d-flex flex-column ms-3 flex-grow-1">
              <div class="d-flex flex-row align-items-end">
                <h1 class="fw-bold font-18 m-0">
                  <a target="_blank" rel="noopener noreferrer" [href]="element.link">
                    <img *ngIf="element.partner" height="48" class="partner_logo" [src]="element.partner.logo" loading="lazy"/>
                  </a>
                  <a target="_blank" rel="noopener noreferrer" class="no-decoration" [href]="element.link">
                    {{ element.partner_ref}}
                  </a>
                  <mat-icon style="vertical-align: text-top" class="copy-icon mt-2 font-10 pointer lightGray2 va-sub" ngbPopover="Copié !" placement="right"
                    (click)="$event.stopPropagation();copyText(element,false)">filter_none
                  </mat-icon>
                </h1>
              </div>
              <div class="mediumGray font-12 ">
                <a rel="nofollow noopener noreferrer" target="_blank" class="no-decoration" href="{{ currentLanguage + '/accommodation/property/' + element.id }}">
                  <span class="lightGray font-14 ms-1 fw-light">#{{element.id}}</span>
                </a>
                <a rel="nofollow noopener noreferrer" target="_blank" class="no-decoration" href="{{ currentLanguage + '/accommodation/property/' + element.id }}">
                  {{ element.name }}
                </a>
                <mat-icon style="vertical-align: text-top" class="copy-icon mt-1 font-10 pointer lightGray2 va-sub" ngbPopover="Copié !" placement="right"
                  (click)="$event.stopPropagation();copyText(element,true)">filter_none
                </mat-icon>
              </div>
              <div class="mediumGray font-12 ">
                <b>{{ element.city_group }} </b>
                {{ element.address ? element.address : 'NA' }}
                ,
                {{element.city ? element.city : 'NA'}}
                ( {{element.postal_code ? element.postal_code : 'NA'}}  )
              </div>
              <div class="col-12 row mt-3">

                <div class="d-flex flex-row align-items-center w-100">
                      <span class="mediumGray">
                        <b>{{ element.contact ? element.contact.name : 'N/A' }} - </b>
                      </span>
                  <i>
                    <a target="_blank" rel="noopener noreferrer" class="no-decoration ps-1" [href]="element.link">
                      {{ element.partner ? element.partner.name : 'N/A' }}
                    </a>
                  </i>
                </div>
                <div class="col-12">
                  <div class="font-12 text-start lightGray75">
                    <a class="lightGray" href="mailto:{{element.contact.email}}" *ngIf="element.contact && element.contact.email">{{ element.contact.email }}</a>
                    <span *ngIf="!element.contact || !element.contact.email">N/A</span>
                  </div>
                </div>

                <div class="col-12">
                  <div class="font-12">
                    {{ element.contact ? (element.contact.phone_number ? element.contact.phone_number : 'N/A') : 'N/A' }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </td>
      </ng-container>

      <!-- Partner Information Column -->
      <ng-container matColumnDef="partner">
        <th mat-header-cell *matHeaderCellDef mat-sort-header="partner" class="border-bottom-0"></th>
        <td mat-cell *matCellDef="let element" class="py-3 px-2 border-top-0 border-bottom-0 border-end">
          <div class="d-flex flex-column align-items-center w-100 h-100 justify-content-center">
            <div class="col-12 row px-0 mx-0">
              <div class="col-8 pt-2">
                <div class="font-12 lightGray">
                  <!--  Disponibilité  -->
                  <span>Disponibilité : </span>
                  <span *ngIf="!element.disponibility"><b>N/A</b></span>
                  <span *ngIf="element.disponibility"><b>{{ element.disponibility.replace(' ', 'T') | date:'shortDate':'':'FR' }}</b></span>
                </div>
              </div>
              <div class="col-4 font-12 lightGray pt-2">
                Durée : <b>{{ (element.minimal_stay_duration ? (element.minimal_stay_duration / 30 < 1 ? 1 : element.minimal_stay_duration / 30) : element.partner.reservation_min) | round: 'down' }} mois</b>
              </div>
              <div class="col-4 font-12 lightGray pt-2">
                Loyer : <b>{{element.price + element.charges_amount}}€</b>
              </div>
              <div class="col-4 font-12 lightGray pt-2">
                Frais LF : <b>{{element.reservation_fees}}€</b>
              </div>
              <div class="col-4 font-12 lightGray pt-2">
                Frais P : <b>{{element.partner_fees}}€</b>
              </div>
              <div class="col-8 font-12 lightGray pt-2">
                Status : <b [ngClass]="{
                      'text-danger' : this.printStatus(element) == 'Non disponible',
                      'text-success' : this.printStatus(element) == 'Disponible',
                      'text-primary' : this.printStatus(element) == 'Réservée'
                    }">{{this.printStatus(element)}}</b>
              </div>
              <div class="col-12 font-12 lightGray pt-2" *ngIf="element.bypass_feed">
                <span class="text-warning" *ngIf="element.bypass_feed">Bypass : </span>
                <b *ngIf="element.bypass_feed && element.bypassDatas">
                  {{element.bypassDatas.typeOfBypass}}
                </b>
                <b *ngIf="element.bypass_feed">
                  {{element.bypass_feed}}
                </b>
              </div>
              <div class="col-12 font-12 lightGray pt-2" *ngIf="element.bypassDatas && element.bypass_feed">
                <span class="text-warning" *ngIf="element.bypassDatas && element.bypassDatas.bypassBy">
                  Bypass par : </span>
                <b *ngIf="element.bypassDatas?.bypassBy?.firstname && element.bypassDatas?.bypassBy?.lastname">
                  {{element.bypassDatas?.bypassBy?.firstname}} {{element.bypassDatas?.bypassBy?.lastname}}
                </b>
              </div>

              <div class="col-12 font-12 lightGray pt-2" *ngIf="element.bypassDatas && element.bypass_feed">
                <span class="text-warning" *ngIf="(element.bypassDatas.bypassCommentary || element.bypassDatas.bypass_commentary)">Commentaire du Bypass : </span><b *ngIf="element.bypassDatas.bypassCommentary || element.bypassDatas.bypass_commentary">  {{ element.bypassDatas.bypassCommentary || element.bypassDatas.bypass_commentary }}</b>
              </div>

              <div class="col-12 font-12 lightGray pt-2" *ngIf="element.forceBlocked && element.forceBlocked_datas && element.forceBlocked >= currentDate">
                <span class="text-danger" *ngIf="element.forceBlocked_datas && element.forceBlocked_datas.typeOfBlock">Bloquée : </span><b *ngIf="element.forceBlocked_datas.typeOfBlock"> {{element.forceBlocked_datas.typeOfBlock}}</b>
              </div>
              <div class="col-12 font-12 lightGray pt-2" *ngIf="element.forceBlocked && element.forceBlocked_datas && element.forceBlocked >= currentDate">
                <span class="text-danger" *ngIf="element.forceBlocked_datas && element.forceBlocked_datas.blockedBy">Bloquée par : </span>
                <b *ngIf="element.forceBlocked_datas?.blockedBy?.firstname && element.forceBlocked_datas?.blockedBy?.lastname">
                  {{element.forceBlocked_datas?.blockedBy?.firstname}} {{element.forceBlocked_datas?.blockedBy?.lastname}}
                </b>
              </div>
              <div class="col-12 mt-3 d-flex justify-content-between align-items-center mx-0 px-0 gap-8" *ngIf="element.partner_type !='apartment'">
                <div class="infoBtnStyle flex-grow-1">{{element.dispoInHouse}}
                  dispo
                </div>
                <div class="infoBtnStyle flex-grow-1">{{element.nbRooms}}
                  coloc
                </div>
                <div class="infoBtnStyle flex-grow-1">
                  <i class="text-dark fa fa-bath "></i>
                  {{element.bathrooms_private ? 'Privée' : 'Partagée'}}
                </div>
                <div class="infoBtnStyle flex-grow-1">
                  <svg xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 384 512">
                    <path d="M368 48c8.8 0 16-7.2 16-16V16c0-8.8-7.2-16-16-16H16C7.2 0 0 7.2 0 16v16c0 8.8 7.2 16 16 16h16v156.7C11.8 214.8 0 226.9 0 240c0 67.2 34.6 126.2 86.8 160.5l-21.4 70.2C59.1 491.2 74.5 512 96 512h192c21.5 0 36.9-20.8 30.6-41.3l-21.4-70.2C349.4 366.2 384 307.2 384 240c0-13.1-11.8-25.2-32-35.3V48h16zM80 72c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8H88c-4.4 0-8-3.6-8-8V72zm112 200c-77.1 0-139.6-14.3-139.6-32s62.5-32 139.6-32 139.6 14.3 139.6 32-62.5 32-139.6 32z"/>
                  </svg>
                  {{element.wc_private ? 'Privé' : 'Partagé'}}
                </div>
                <app-item-badges [element]="element" *ngIf="element.badges"></app-item-badges>
              </div>
              <div class="col-12 mt-3 d-flex justify-content-between align-items-center mx-0 px-0 gap-8" *ngIf="element.partner_type == 'apartment'">
                <div class="col-3 infoBtnStyle">N.A pièces</div>
                <div class="col-3 infoBtnStyle">{{element.meter}}</div>
                <app-item-badges [element]="element" *ngIf="element.badges"></app-item-badges>
              </div>
            </div>
          </div>
        </td>
      </ng-container>

      <!-- Property's progress Column -->
      <ng-container matColumnDef="progress">

        <th mat-header-cell *matHeaderCellDef class="text-center border-bottom-0" mat-sort-header="progress"></th>
        <td mat-cell *matCellDef="let element" class="w-0 py-3 border-top-0 border-bottom-0 border-end">
          <div class="ms-4">
            <div>
              <span (click)="openModal(propertyParams, element )" class="pointer pptyDatas" [ngClass]="element.photosVerified !== 'verified' ? 'inactive' : '' ">Photo</span>
              <span (click)="openModal(propertyParams, element )" class="pointer pptyDatas" [ngClass]="!element.bathroomVerified ? 'inactive' : '' ">Bathroom</span>
              <span (click)="openModal(propertyParams, element )" class="pointer pptyDatas" [ngClass]="!element.wcVerified ? 'inactive' : '' ">Toilet</span>
              <span (click)="openModal(propertyParams, element )" class="pointer pptyDatas" [ngClass]="!element.virtualVisitVerified ? 'inactive' : '' ">Virtual</span>
              <span (click)="openModal(propertyParams, element )" class="pointer pptyDatas" [ngClass]="element.bathrooms_private == 1 || element.nbBathroom > 0 ? '' : 'inactive' ">Nb Bathroom</span>
              <span (click)="openModal(propertyParams, element )" class="pointer pptyDatas" [ngClass]="element.wc_private == 1 || element.nbWc > 0 ? '' : 'inactive' ">Nb Toilet</span>
            </div>
          </div>
        </td>
      </ng-container>
      <!-- Property's action Column -->
      <ng-container matColumnDef="action">

        <th mat-header-cell *matHeaderCellDef class="text-center border-bottom-0" mat-sort-header="action"></th>
        <td mat-cell *matCellDef="let element" class="w-0 py-3 border-top-0 border-bottom-0">

          <div class="ms-4">
            <div>
              <span (click)="openModalb(blockModal,element)" class="pointer pptyDatas btnMode mb-3"
                [ngClass]="element.forceBlocked >= currentDate ? 'inactive' : '' ">Bloquer</span>
              <span (click)="openModal(propertyParams, element )" class="pointer pptyDatas btnMode mb-3">Modifier</span>
              <span (click)="openModalBadge(badgeParams, element )" class="pointer pptyDatas btnMode mb-3">Marketing</span>
            </div>
          </div>


        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      <!-- Row shown when there is no matching data. -->
      <tr class="mat-row" *matNoDataRow>
        <td class="mat-cell" colspan="4">Aucun résultats trouvés.</td>
      </tr>
    </table>
  </div>




  <mat-paginator #backproperties class="w-100 sticky-bottom mt-auto" [length]="100" hidePageSize="false" [pageSizeOptions]="[5, 10, 25, 50, 100]" showFirstLastButtons [hidden]="properties && properties.length === 0"></mat-paginator>

</div>
<div class="btn-top-scroll" (click)="scrollToTop()" [ngClass]="{ 'show-scroll': windowTopScrolled }">
  <button class="btn btn-lf-secondary border-2 txt-darkGray">
    <span class="material-icons-outlined">arrow_upward</span>
  </button>
</div>

<div class="btn-bottom-scroll" (click)="scrollToBottom()" [ngClass]="{ 'show-scroll': windowBottomScrolled }">
  <button class="btn btn-lf-secondary border-2 txt-darkGray">
    <span class="material-icons-outlined rotate">arrow_upward</span>
  </button>
</div>

<!-- property params -->
<ng-template #propertyParams let-modal>
  <div class="modal-container pptyModal p-4">
    <div class="col-12 row position-relative align-items-center px-3">
      <div class="row pb-3 border-bottom" *ngIf="!isLoading">
        <span class="col fw-bold px-2" *ngIf="otherRooms && otherRooms.length > 0">{{editPpty.prefix}}</span>
        <div class="col px-2 d-flex" *ngFor="let otherRoom of otherRooms" (click)="otherRoom.id !== this.editPpty.id && changeRoom(otherRoom)" [ngClass]="{'fw-bold' : otherRoom.id === editPpty.id, 'house-link': otherRoom.id !== editPpty.id}">
          <span>{{splitName(otherRoom.name)}}</span>
          <lf-icon class="ps-2" name="greenCheck" height="14px" width="14px" *ngIf="IsPptyVerified(otherRoom) === 1"></lf-icon>
        </div>
      </div>
        <div class="d-flex justify-content-between pt-3">
          <div class="d-flex gap-12">
            <button (click)="openModalbypass(bypassModal,editPpty)" class=" btn btn-warning btn-sm text-white  mb-3 mt-2 me-0">
              Bypass
            </button>
            <button [ngClass]="editPpty.forceBlocked == null || editPpty.forceBlocked <= currentDate ? 'btn-success' : 'btn-danger'"
                    class="btn btn-sm mb-3 mt-2 me-0">
              <ng-container *ngIf="editPpty.forceBlocked == null || editPpty.forceBlocked <= currentDate else blockTemplate ">
                Non bloquée
              </ng-container>
              <ng-template #blockTemplate>Bloquée</ng-template>
            </button>
          </div>

          <div class="text-end pe-0">
            <a target="_blank" rel="noopener noreferrer" class="font-14 px-4" [href]="editPpty.link">Lien du partenaire</a>
            <a target="_blank" rel="noopener noreferrer" class="font-14 px-4" [href]="currentLanguage + '/accommodation/property/' + editPpty.id">Lien Livinfrance</a>
            <span class="fw-bold">#{{editPpty.id}}</span>
            <span href="#"><img *ngIf="editPpty.partner" height="48" [src]="editPpty.partner.logo" loading="lazy"/></span>
          </div>
        </div>
      <div class="d-flex align-items-start justify-content-center h-100" *ngIf="isLoading">
        <div class="spinner-border text-primary"></div>
      </div>
      <div *ngIf="!isLoading">
        <div class="row">
          <div class="col-12 mt-4">
            <div class="row">
              <div class="d-flex pt-3 pb-3 border-bottom ">
                <div class="col-3">
                  <h4>Toilette</h4>
                </div>
                <div class="col-3 d-flex justify-content-start">
                  <button (click)="updatePropertyField(editPpty.id,'wc_private',1)" [ngClass]="editPpty.wc_private ? 'btn-primary' : 'btn-outline-primary'" class="btn btn-sm">
                    Privée
                  </button>
                  <button (click)="updatePropertyField(editPpty.id,'wc_private',0)" [ngClass]="!editPpty.wc_private ? 'btn-primary' : 'btn-outline-primary'" class="btn btn-sm mx-3">
                    Partagée
                  </button>
                </div>
                <div *ngIf="!editPpty.wc_private" class="col-3 d-flex justify-content-start">
                  <span class="d-flex align-items-center pe-2">Nombre de toilette</span>
                  <select (change)="updatePropertyField(editPpty.id,'nbWc',$event.target.value)" id="nbWc" class="form-control w-20" [ngModel]="editPpty.nbWc">
                    <option *ngFor="let option of numbers" [value]="option">{{option}}</option>
                  </select>
                </div>
                <div class=" d-flex justify-content-end "[ngClass]="!editPpty.wc_private ? 'col-3' : 'col-6'">
                  <button (click)="updatePropertyField(editPpty.id,'wcVerified',!editPpty.wcVerified)" [ngClass]="editPpty.wcVerified ? 'btn-success' : 'btn-outline-danger'" class="btn btn-sm">
                    <span *ngIf="editPpty.wcVerified">Vérifiée</span>
                    <span *ngIf="!editPpty.wcVerified">Non vérifiée</span>
                  </button>
                </div>
              </div>
              <div class="d-flex pt-3 pb-3 border-bottom">
                <div class="col-3">
                  <h4>Salle de bain</h4>
                </div>
                <div class="col-3 d-flex justify-content-start">
                  <button (click)="updatePropertyField(editPpty.id,'bathrooms_private',1)" [ngClass]="editPpty.bathrooms_private ? 'btn-primary' : 'btn-outline-primary'" class="btn  btn-sm">
                    Privée
                  </button>
                  <button (click)="updatePropertyField(editPpty.id,'bathrooms_private',0)" [ngClass]="!editPpty.bathrooms_private ? 'btn-primary' : 'btn-outline-primary'" class="btn  btn-sm mx-3">
                    Partagée
                  </button>
                </div>
                <div *ngIf="!editPpty.bathrooms_private" class="col-3 d-flex justify-content-start">
                  <span class="d-flex align-items-center pe-2">Nombre de SDB</span>
                  <select (change)="updatePropertyField(editPpty.id,'nbBathroom',$event.target.value)" id="nbBathroom" class="form-control w-20" [ngModel]="editPpty.nbBathroom">
                    <option *ngFor="let option of numbers" [value]="option">{{option}}</option>
                  </select>
                </div>
                <div class="d-flex justify-content-end" [ngClass]="!editPpty.bathrooms_private ? 'col-3' : 'col-6'">
                  <button (click)="updatePropertyField(editPpty.id,'bathroomVerified',!editPpty.bathroomVerified)" [ngClass]="editPpty.bathroomVerified ? 'btn-success' : 'btn-outline-danger'" class="btn btn-sm">
                    <span *ngIf="editPpty.bathroomVerified">Vérifiée</span>
                    <span *ngIf="!editPpty.bathroomVerified">Non vérifiée</span>
                  </button>
                </div>
              </div>
              <div class="d-flex pt-3 pb-3 border-bottom">
                <div class="col-3">
                  <h4>Virtual tour</h4>
                </div>
                <div class="col-3 d-flex justify-content-start">
                  <button (click)="updatePropertyField(editPpty.id,'hideVirtualVisit',1)" [ngClass]="editPpty.hideVirtualVisit ? 'btn-primary' : 'btn-outline-primary'" class="btn btn-sm">
                    Hors ligne
                  </button>
                  <button (click)="updatePropertyField(editPpty.id,'hideVirtualVisit',0)" [ngClass]="!editPpty.hideVirtualVisit ? 'btn-primary' : 'btn-outline-primary'" class="btn btn-sm mx-3">
                    En ligne
                  </button>
                </div>
                <div class="col-3 d-flex justify-content-start align-items-center">
                  <a class="font-14 house-link" (click)="openVVLink(editPpty.virtualVisit)" *ngIf="editPpty.virtualVisit">Lien de la visite virtuelle</a>
                </div>
                <div class="col-3 d-flex justify-content-end">
                  <button (click)="updatePropertyField(editPpty.id,'virtualVisitVerified',!editPpty.virtualVisitVerified)" [ngClass]="editPpty.virtualVisitVerified ? 'btn-success' : 'btn-outline-danger'" class="btn btn-sm justify-content-end" >
                    <span *ngIf="editPpty.virtualVisitVerified">Vérifiée</span>
                    <span *ngIf="!editPpty.virtualVisitVerified">Non vérifiée</span>
                  </button>
                </div>
              </div>

            </div>
          </div>
          <div class="col-12 mt-4 border rounded">
            <div class="row">
              <div class="d-flex pt-3 pb-3 align-items-center">
                <h4>
                  Photos
                </h4>
                <div class="col d-flex justify-content-start ms-3">
                  <button class="btn btn-sm btn-primary btn-link mb-3 me-2 mt-2 text-white"
                     (click)="downloadSelectionPhoto()"
                     [ngClass]="selectedPhotos.length === 0 ? 'btn-interaction' : 'btn-primary'"
                      disabled>
                    <i class="fa fa-download"></i>
                  </button>

                  <a class="btn btn-sm btn-primary btn-link mb-3 me-2 mt-2 text-white" (click)="newImg.click()">
                    <lf-icon name="upload" fillColor="#FFFFFFFF" height="13px" width="14px"></lf-icon>
                  </a>
                  <input multiple type="file" class="d-none file-input" (change)="onFileSelected($event, null)" #newImg>

                  <button class="btn btn-sm btn-lf btn-danger mb-3 me-2 mt-2 text-white"
                          (click)="deleteSelectionPhoto()"
                          [ngClass]="selectedPhotos.length === 0 ? 'btn-interaction' : 'btn-danger'"
                          [disabled]="selectedPhotos.length === 0">
                    <i class="fa fa-trash"></i>
                  </button>
                </div>


                <div class="col d-flex justify-content-end">
                  <select (change)="updatePropertyField(editPpty.id,'photosVerified',$event.target.value)" id="photosVerified" class="btn btn-sm" [ngClass]="editPpty.photosVerified === 'verified' ? 'btn-success' : 'btn-outline-danger'" [ngModel]="editPpty.photosVerified">
                    <option *ngFor="let photoReason of photoVerifiedList" [value]="photoReason.value">{{photoReason.name}}</option>
                  </select>
                </div>
              </div>
            </div>

            <div class="d-flex pb-3">
              <input type="checkbox" [(ngModel)]="selectPhotos" (change)="selectAllPhotos()" class="me-3 checkboxGrey"/>
              <span class="d-flex align-items-center">- Sélection ({{selectedPhotos.length}})</span>

              <div class="col d-flex justify-content-end">
                <button class="btn btn-sm btn-primary mb-3 mt-2 me-2 text-white" (click)="updatePhotos()">Enregistrer
                </button>
              </div>
            </div>
            <div class="row" *ngIf="propertyPhotosList && propertyPhotosList.length > 0">
              <div appDragDrop class="col-3 drag-wrapper d-block mb-3" *ngFor="let pimg of propertyPhotosList; let index = index"
                [draggable]="true"
                [class.dragging]="pimg === this.draggingIndex"
                (dragstart)="onDragStart(pimg)"
                (dragenter)="onDragEnter(pimg)"
                (dragend)="onDragEnd()">
                <div class="d-block">
                  <span>{{index + 1}}.</span>
                </div>
                <div class="position-relative d-inline-block">
                  <img class="w-100" [src]="pimg.photo" loading="lazy"/>
                  <span class="badge" *ngIf="pimg.cover_photo">Couverture</span>
                </div>
                <div class="row my-3">
                  <div class="col-2 ps-4 text-start">
                    <input type="checkbox" [ngModel]="isChecked('photo',pimg)" (ngModelChange)="toggleCheckbox('photo', $event, pimg)" class="me-3 checkboxGrey"/>
                  </div>
                  <div class="col-10 text-end">
                    <input type="file" class="d-none file-input" (change)="onFileSelected($event, pimg)" #fileUpload>
                    <a class="btn btn-link btn-primary f-14 me-1 px-2 p-1 pb-0 text-white h-100" (click)="uploadId=pimg.id;fileUpload.click()">
                      <lf-icon name="upload" fillColor="#FFFFFFFF" height="13px" width="14px"></lf-icon>
                    </a>
                    <a class="btn btn-success f-14 me-1 px-2 p-1 pb-0 text-white" (click)="setCoverPhoto(pimg, editPpty)"><i class="fa fa-image"></i></a>
                    <a class="btn btn-link btn-primary f-14 me-1 px-2 p-1 pb-0 text-white" target="_blank noopener noreferrer" [href]="pimg.photo" download><i class="fa fa-download"></i></a>


                    <a class="btn btn-danger f-14 px-2 p-1 pb-0 text-white" (click)="deletePhoto(pimg.id)"><i class="fa fa-trash"></i></a>
                  </div>
                </div>
              </div>
            </div>
            <div class="p-4 text-center" *ngIf="!propertyPhotosList || propertyPhotosList.length == 0">
              Pas de photos pour ce logement.
            </div>
          </div>
          <div class="col-12 mt-4">
            <button (click)="updatePropertyField(editPpty.id,'isAvailableForCertificate',!editPpty.isAvailableForCertificate)" [ngClass]="editPpty.isAvailableForCertificate ? 'btn-lf-secondary' : 'btn-lf btn-outline-danger'" class="btn btn-sm" >
              <span *ngIf="editPpty.isAvailableForCertificate">Ajouter le logement pour l'attestation</span>
              <span *ngIf="!editPpty.isAvailableForCertificate">Retirer le logement pour l'attestation</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<!-- badge params -->
<ng-template #badgeParams let-modal>
  <div class="modal-container badgeModal pptyModal py-3 px-3  admin">
    <div class="col-12 row position-relative align-items-center p-3">
      <div class="d-flex justify-content-between pb-3 border-bottom">
        <h3 class="text-success title_1 m-0">Marketing</h3>
        <button type="button" class="btn border-0 m-0 ms-auto p-0" aria-label="Close" (click)="modal.dismiss()">
          <span class="material-icons-outlined text-black">close</span>
        </button>
      </div>
      <div class="d-flex align-items-baseline mt-4" [ngClass]="badgeSelected == 'isPromoted' ? 'justify-content-between' : 'justify-content-center'">
        <mat-form-field appearance="fill">
          <mat-label>Badge</mat-label>
          <mat-select [formControl]="badgeFC">
            <mat-option *ngFor="let badge of badgesList" [value]="badge.value" (click)="changeBadgeSelected(badge)">{{badge.name}}</mat-option>
          </mat-select>
        </mat-form-field>


        <div class="d-flex br-8 p-3 bg-grey flex-column col-7" *ngIf="badgeSelected == 'isPromoted'">
          <mat-form-field>
            <mat-date-range-input [rangePicker]="promopicker">
              <input matStartDate [(ngModel)]="startDatePromo" placeholder="Date de début">
              <input matEndDate [(ngModel)]="endDatePromo" placeholder="Date de fin">
            </mat-date-range-input>
            <mat-datepicker-toggle matIconSuffix [for]="promopicker"></mat-datepicker-toggle>
            <mat-date-range-picker #promopicker></mat-date-range-picker>
          </mat-form-field>

          <mat-form-field appearance="fill">
            <mat-label>Type de promotion</mat-label>
            <mat-select [formControl]="typePromoFC">
              <mat-option *ngFor="let typePromo of typePromoList" [value]="typePromo.value">{{typePromo.name}}</mat-option>
            </mat-select>
          </mat-form-field>

          <div class="d-flex gap-5 mt-4">
            <div class="position-relative">
              <span class="label subtitle_1 form-label-color text-black rescale text-nowrap">Type de réduction</span>
              <mat-radio-group [(ngModel)]="typeReduc" class="d-flex gap-16 flex-wrap">
                <mat-radio-button *ngFor="let value of ['euro', 'percentage']"
                  [ngClass]="{'fw-bold' : typeReduc === value}" class="text_2" value="{{value}}">
                  {{ value === 'euro' ? '€' : '%' }}
                </mat-radio-button>
              </mat-radio-group>
            </div>

            <div class="position-relative">
              <label class="subtitle_2 rescale form-label-color text-black text-nowrap" for="promo_price">Montant de la
                réduction :</label>
              <div class="form_inputs px-2 py-1 d-flex">
                <input numberOnly [(ngModel)]="promoReduc"
                  class="w-100 border-0 minitext_3"
                  id="promo_price"
                  min="0"
                  placeholder="écrire ici" size="5" type="number">
                <div class="input-prefix text_2 ps-2 pe-1 border-opacity-50">{{ typeReduc === 'euro' ? '€' : '%' }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-12 d-flex justify-content-center pt-3">
        <mat-checkbox [(ngModel)]="isFeatured">Remonter dans les résultats de recherche</mat-checkbox>
      </div>

      <div class="col-12 d-flex justify-content-center pt-3">
        <button (click)="validateBadge(true)" class="btn btn-danger mb-1 px-5 py-2" *ngIf="this.badgeFC.value !== 'null'">Annuler badge</button>
      </div>

      <div class="col-12 d-flex justify-content-center pt-3">
        <button (click)="validateBadge()" class="btn btn-primary mb-1 px-5 py-2">Valider</button>
      </div>
    </div>
  </div>
</ng-template>

<!-- modal de blocage -->
<ng-template #blockModal let-modal>
  <div class="blockModal modal-container py-3 px-3 admin">
    <div class="col-12 row position-relative align-items-center p-3">
      <div class="d-flex justify-content-between pb-3 border-bottom">
        <h3 class="text-danger title_1 m-0">Bloquer une propriété</h3>
        <button type="button" class="btn border-0 m-0 p-0" aria-label="Close" (click)="modal.dismiss()">
          <span class="material-icons-outlined text-black">close</span>
        </button>
      </div>

      <div class="d-flex mt-4 justify-content-between">
        <div class="col-4 p-0 m-0 d-flex flex-column text_3">
          <h5 class="title_2">Type</h5>
          <mat-checkbox [(ngModel)]="photoChecked">Photos</mat-checkbox>
          <mat-checkbox [(ngModel)]="dispoChecked">Disponibilités</mat-checkbox>
          <mat-checkbox [(ngModel)]="infosChecked">Infos</mat-checkbox>
          <mat-checkbox [(ngModel)]="travauxChecked">Travaux</mat-checkbox>
          <mat-checkbox [(ngModel)]="notFoundChecked">404</mat-checkbox>
          <mat-checkbox [(ngModel)]="autreChecked">Autre</mat-checkbox>
        </div>

        <div class="col-7 px-3 py-2 br-8 bg-grey d-flex flex-column">
          <h5 class="title_2">Bloquer jusqu'à : </h5>
          <div class="d-flex align-items-center gap-3 mb-3">
            <input type="date" class="rounded px-2" [(ngModel)]="selectedDate" name="selectedDate">
            <p>|</p>
            <button (click)="setDate()" class="px-5 btn btn-outline-secondary">indéfini</button>
          </div>
          <textarea name="commentaire" id="com" cols="50" rows="7" [(ngModel)]="commentaire">commentaire:</textarea>
        </div>
      </div>
      <div class="d-flex flex-row w-100 mt-4 justify-content-center gap-3">
        <button (click)="deblock()" class="btn btn-lf-secondary">Débloquer</button>
        <button (click)="validate()" class="btn btn-primary" [disabled]="!isValidB()">Valider</button>
      </div>
    </div>
  </div>
</ng-template>

<!-- modale ByPass -->
<ng-template #bypassModal let-modalByPass>
  <div class="bypassModal modal-container py-3 px-3 admin">

    <div class="col-12 row position-relative align-items-center p-3">
      <div class="d-flex justify-content-between pb-3 border-bottom">
        <h3 class="text-warning title_1 m-0">Bypass</h3>
        <button type="button" class="btn border-0 m-0 p-0" aria-label="Close" (click)="modalByPass.dismiss()">
          <span class="material-icons-outlined text-black">close</span>
        </button>
      </div>

      <div class="d-flex mt-4 justify-content-between">
        <div class="col-4 p-0 m-0 d-flex flex-column text_3 gap-2">
          <h5 class="title_2">Informations</h5>

          <div class="d-flex justify-content-between">
            <p>Date de dispo:
              <span class="fw-bold" *ngIf="dispoDate">{{dispoDate | date}}</span>
              <span class="fw-bold " [innerHtml]=" editPpty.disponibility ? (editPpty.disponibility | date) : 'indisponible'" *ngIf="!dispoDate"></span>
            </p>
            <input type="date" [(ngModel)]="dispoDate" (ngModelChange)="onDateChange($event)" name="dispoDate" class="ms-auto inputBypassD">
          </div>

          <div class="d-flex justify-content-between">
            <label for="unitRent">Loyer (sans charges): </label>
            <input id="unitRent" class="fw-bold ms-auto input" [(ngModel)]="bLoyer" name="bLoyer" placeholder='{{editPpty.price}}'>€
          </div>

          <div class="d-flex justify-content-between ">
            <label for="unitHonoraire">Honoraires: </label>
            <input id="unitHonoraire" type="text" [(ngModel)]="bHono" name="bHono" placeholder="{{editPpty.reservation_fees}}" class="fw-bold ms-auto inputBypass">€
          </div>

          <div class="d-flex justify-content-between">
            <label for="unitCharges">Charges: </label>
            <input id="unitCharges" class="fw-bold ms-auto inputBypass" [(ngModel)]="bCharges" name="bCharges" placeholder="{{editPpty.charges_amount}}">€
          </div>

          <div class="d-flex justify-content-between">
            <label for="unitFees">Frais partenaire: </label>
            <input id="unitFees" class="ms-auto fw-bold inputBypass" name="partnerFees" [(ngModel)]="partnerFees" placeholder="{{editPpty.partner_fees}}">€
          </div>

          <div class="d-flex justify-content-between">
            <label for="unitGarantie" class="">Dépôt de garantie:</label>
            <input id="unitGarantie" class="ms-auto fw-bold inputBypass" [(ngModel)]="deposit" name="deposit" placeholder="{{editPpty.deposit}}">€
          </div>

          <mat-checkbox class="text-primary" [(ngModel)]="eraseTanent">Ecraser le tenant</mat-checkbox>

        </div>

        <div class="col-7 px-3 py-2 br-8 bg-grey d-flex flex-column">
          <h5 class="title_2">Bypass jusqu'au :</h5>

          <div class="mb-3 d-flex align-items-center">
            <input type="date" class="me-3 rounded px-2" [(ngModel)]="bypassDate" name="bypassDate">
            <p>|</p>
            <button (click)="setDateB()" class="ms-3 px-5 btn btn-outline-secondary">indéfini</button>
          </div>
          <textarea name="bypassCommentary" cols="50" rows="6" [(ngModel)]="bypassCommentary">commentaire:</textarea>
        </div>

      </div>

      <div class="d-flex justify-content-center gap-3 w-100 mt-4">
        <button (click)="cancelBypass()" class="btn btn-lf-secondary ">Annuler Bypass</button>
        <button (click)="validateByPass()" class="btn btn-primary px-5 py-2" [disabled]="!isValidBypass()">Valider</button>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #bypassSelectionModal let-modal>
  <div class="bypassModal modal-container py-3 px-3 admin">

    <div class="col-12 row position-relative align-items-center p-3">
      <div class="d-flex justify-content-between pb-3 border-bottom">
        <h3 class="text-warning title_1 m-0">Bypass</h3>
        <button type="button" class="btn border-0 m-0 p-0" aria-label="Close" (click)="modal.dismiss()">
          <span class="material-icons-outlined text-black">close</span>
        </button>
      </div>

      <div class="d-flex mt-4 justify-content-between">
        <div class="col-4 p-0 m-0 d-flex flex-column text_3 gap-2">
          <h5 class="title_2">Informations</h5>
          <div class="d-flex justify-content-between mb-2">
            <p>Date de dispo:
              <span class="fw-bold" *ngIf="dispoDate">{{dispoDate | date}}</span>
              <span class="fw-bold " [innerHtml]=" dispoDate ? (dispoDate | date) : 'indisponible'" *ngIf="!dispoDate"></span>
            </p>
            <input type="date" [(ngModel)]="dispoDate" name="dispoDate" class=" me-4 inputBypassD">
          </div>

          <mat-checkbox class="text-primary" [(ngModel)]="eraseTanent">Ecraser le tenant</mat-checkbox>
        </div>

        <div class="col-7 px-3 py-2 br-8 bg-grey d-flex flex-column">
          <h5 class="title_2">Bypass jusqu'au :</h5>

          <div class="mb-3 d-flex align-items-center">
            <input type="date" class="me-3 rounded px-2" [(ngModel)]="bypassDate" name="bypassDate">
            <p>|</p>
            <button (click)="setDateB()" class="ms-3 px-5 btn btn-outline-secondary">indéfini</button>
          </div>
          <textarea name="bypassCommentary" cols="50" rows="7" [(ngModel)]="bypassCommentary">commentaire:</textarea>
        </div>
      </div>
      <div class="d-flex justify-content-center gap-3 w-100 mt-4">
        <button (click)="cancelBypass()" class="btn btn-lf-secondary ">Annuler Bypass</button>
        <button (click)="validateByPass()" class="btn btn-primary px-5 py-2" [disabled]="!isValidSelectionBypass()">Valider</button>
      </div>
    </div>
  </div>
</ng-template>

<!-- Modal de chargement -->
<!-- Modal de chargement avec barre de progression -->
<ng-template #loadingModal let-modal>
  <div class="modal-header d-flex justify-content-center pb-3">
    <h4 class="modal-title">Chargement en cours</h4>
  </div>
  <div class="modal-body d-flex flex-column justify-contet-center pb-3">
    <p class="d-flex justify-content-center pb-3">
      Les photos sont en cours de chargement...
    </p>
    <div class=" d-flex align-items-center justify-content-center" *ngIf="!isprogress">
      <div class="spinner-border text-primary"></div>
    </div>
    <div *ngIf="isprogress" class="progress">
      <div class="progress-bar" role="progressbar" [style.width.%]="progressValue"
           [attr.aria-valuenow]="progressValue" aria-valuemin="0" aria-valuemax="100">
        {{ progressValue }}%
      </div>
    </div>
  </div>
</ng-template>




<!-- Modal de deblocage -->
<ng-template #deblockModal let-modal>
  <div class="modal-container blockModal p-3">
    <h4 class="text-primary fw-bold mb-4">Débloquer les logements sélectionnées ?</h4>
    <div class="d-flex justify-content-center gap-12">
      <div>
        <button (click)="deblock()" class="btn btn-success mb-1 px-5 py-2">Confirmer</button>
      </div>
      <div>
        <button (click)="closeModal()" class="btn btn-danger mb-1 px-5 py-2">Annuler</button>
      </div>
    </div>


  </div>

</ng-template>

<ng-template #VVModal let-modal>
  <div [innerHTML]="editPpty.virtualVisit" class="jkl">
  </div>
  <button class="btn position-absolute photo_close_btn border-0" (click)="modal.dismiss()">
    <span class="material-icons-outlined text-white">close</span>
  </button>
</ng-template>

